// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".calendar-shares .app-navigation-entry__select[data-v-19976c5a] .v-select{width:100%}", "",{"version":3,"sources":["webpack://./src/components/AppNavigation/CalendarShare.vue"],"names":[],"mappings":"AACA,0EACC,UAAA","sourcesContent":["\n.calendar-shares .app-navigation-entry__select :deep(.v-select) {\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
